import {Component, OnDestroy} from '@angular/core';
import {AlertComponent} from "../../common/alert/alert.component";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {MapsService, MapType} from "./maps.service";
import {AlertService} from "../../common/alert/alert.service";

@Component({
    selector: 'app-admin-maps',
    templateUrl: './maps.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent
    ],
    styleUrls: ['./maps.component.css'],
    providers: [AlertService]
})
export class MapsComponent implements OnDestroy {
    private formBuilder = new FormBuilder().nonNullable
    private facilityId = this.formBuilder.control("")
    private mapType = this.formBuilder.control(MapType.Google)
    private subscriptions: Subscription[] = [];

    isLoading: boolean = false;
    courseForm = new FormGroup({
        facilityId: this.facilityId,
        mapType: this.mapType
    });

    constructor(private service: MapsService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    update() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.subscriptions.push(
            this.service
                .update(this.facilityId.value, this.mapType.value)
                .subscribe(value => {
                    this.isLoading = false;
                    if (value) {
                        this.facilityId.setValue("")
                        this.alertService.showAlert('success', "Facility map updated");
                    } else {
                        this.alertService.showAlert('danger', "An error occurred");
                    }
                })
        );
    }

    protected readonly MapType = MapType;
}
